import { MetaReducer } from '@ngrx/store';
import { clearStateMetaReducer } from './clear-state.reducer';

export const metaReducers: MetaReducer[] = [clearStateMetaReducer];
